export default {
  beforeMount() {
    const account = window.stripeAccountId
      ? window.stripeAccountId
      : this.$root.Union.stripe_account_id

    this.stripe = account ?
      Stripe(window.stripePublicKey, { stripeAccount: account }) :
      Stripe(window.stripePublicKey)
  },
  data() {
    return {
      stripe: null,
    }
  },
}
